import { Component, OnDestroy, TemplateRef, ViewChild } from '@angular/core';
import { SvgIconComponent } from 'angular-svg-icon';
import { Observable, Subject, takeUntil } from 'rxjs';
import { LoaderService } from '../../../../../core/services/loader.service';
import { DrawerService } from '../../../../../core/services/drawer.service';
import { DRAWER_IDS } from '../../../../../core/constants/drawer-ids.constant';
import {
  CaseDetailModel,
  EditBehaviorDrawerParams,
} from '../../../insights.interface';
import { InsightMode } from '../../../insights.enums';
import { CommonModule } from '@angular/common';
import { NzSpinModule } from 'ng-zorro-antd/spin';
import { NzRadioGroupComponent, NzRadioModule } from 'ng-zorro-antd/radio';
import {
  FormBuilder,
  FormGroup,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { CreateReportComponent } from './create-report/create-report.component';
import { EditReportComponent } from './edit-report/edit-report.component';
import { DrawerHeaderComponent } from '../../../../../components/drawer-header/drawer-header.component';

@Component({
  selector: 'app-report-manager',
  standalone: true,
  imports: [
    SvgIconComponent,
    CommonModule,
    NzSpinModule,
    NzRadioGroupComponent,
    NzRadioModule,
    ReactiveFormsModule,
    NzButtonModule,
    DrawerHeaderComponent,
  ],
  templateUrl: './report-manager.component.html',
})
export class ReportManagerComponent implements OnDestroy {
  @ViewChild('createTpl') createTpl!: TemplateRef<void>;
  @ViewChild('editTpl') editTpl!: TemplateRef<void>;
  loading$: Observable<boolean>;
  private readonly destroy$ = new Subject<void>();
  caseParams: EditBehaviorDrawerParams = {
    case: {} as CaseDetailModel,
    mode: InsightMode.PRINT_CASE,
  };
  reportTypeForm!: FormGroup;
  caseDetail: CaseDetailModel = {} as CaseDetailModel;
  constructor(
    private readonly loaderService: LoaderService,
    private readonly drawerService: DrawerService,
    private readonly fb: FormBuilder
  ) {
    this.loading$ = this.loaderService.loading$;
    this.reportTypeForm = this.fb.group({
      reportType: ['', Validators.required],
    });
    this.setupDrawerSubscription();
  }

  private setupDrawerSubscription(): void {
    this.drawerService
      .getParams<EditBehaviorDrawerParams>(DRAWER_IDS.REPORT_MANAGER)
      .pipe(takeUntil(this.destroy$))
      .subscribe(params => {
        if (params) {
          this.caseParams = params;
          this.caseDetail = params.case;
        }
      });
  }

  onNext() {
    if (this.reportTypeForm.value.reportType === 'create') {
      this.openCreateReportDrawer();
    } else {
      this.openEditReportDrawer();
    }
  }

  openCreateReportDrawer() {
    this.drawerService
      .openDrawer(
        CreateReportComponent,
        this.createTpl as unknown as TemplateRef<object>,
        1170,
        true,
        undefined,
        {
          case: this.caseDetail,
          mode: InsightMode.CREATE_REPORT,
        },
        DRAWER_IDS.CREATE_REPORT
      )
      .afterClose.subscribe(res => {
        if (res?.isSuccess) {
          const drawerRef = this.drawerService.getDrawerRef(
            DRAWER_IDS.REPORT_MANAGER
          );
          drawerRef?.close(res);
        }
      });
  }

  openEditReportDrawer() {
    this.drawerService.openDrawer(
      EditReportComponent,
      this.editTpl as unknown as TemplateRef<object>,
      1170,
      true,
      undefined,
      {
        case: this.caseDetail,
        mode: InsightMode.EDIT_REPORT,
      },
      DRAWER_IDS.EDIT_REPORT
    );
  }

  closerEditDrawer() {
    this.drawerService.closeDrawer(DRAWER_IDS.EDIT_REPORT);
  }
  onCancel() {
    this.drawerService.closeDrawer(DRAWER_IDS.REPORT_MANAGER);
  }
  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
